
import { Options, Vue } from 'vue-class-component';
import { CompanyFabricCompositionClient } from '@/services/Services';
import UploadFabricExcelModal from '../modals/uploadFabricExcelModal.vue';
import store from '@/store';
import * as OM from '@/Model';
import * as VM from '@/viewModel';

@Options({
    components: {}
})
export default class FabricCompositions extends Vue {

    fabricCompositions: OM.CompanyFabricCompositions[] = [];
    isReadOnly: boolean = false;
    roles = VM.Roles;

    created() {
        this.isReadOnly = store.state.loggedUser.role == this.roles.ReadOnly;
        this.init();
    }

    init() {
        CompanyFabricCompositionClient.getAllByLoggedCompany()
        .then(x => {
            this.fabricCompositions = x;
        })
    }

    uploadExcelModal() {
       this.$opModal.show(UploadFabricExcelModal, {
            callback: () => {
                this.$opModal.closeLast();
                this.init();
            }
       })
    }

}
